exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width {\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/modify-card/edit-card/edit-card.component.css
// module id = ../../../../../src/app/hq/cards/modify-card/edit-card/edit-card.component.css
// module chunks = main